import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { RouteComponentProps } from "utils/routerCompat";
import { ITrainingVideo } from "services/api/types";
import { allModules as api } from "services/api";
import { Typography } from "@mui/material";
import { Page } from "components/Shell/Page";

type Props = RouteComponentProps<{
  id: string;
}>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(3),
    },
    video: {
      width: "100%",
      maxWidth: 800,
      borderRadius: 8,
      outline: "none",
      boxShadow: theme.shadows[3],
    },
    title: {
      marginBottom: theme.spacing(2),
      textAlign: "center",
    },
  }),
);

const WatchVideoComponent = (props: Props) => {
  const classes = useStyles();
  const [video, setVideo] = React.useState<ITrainingVideo | undefined>();

  React.useEffect(() => {
    const load = async () => {
      console.log("Load called");
      const video = await api.shared.trainingVideos.getSingleVideo(
        props.match.params.id,
      );

      console.log({ video });
      setVideo(video);
    };

    load();
  }, [props.match.params.id]);

  return (
    <Page
      maxWidth="lg"
      title="Video Tutorial"
      isLoading={!video}
      isLoaded={Boolean(video)}
      render={() => {
        return (
          <div className={classes.root}>
            {video && (
              <>
                <Typography variant="h1">{video.name}</Typography>
                <Typography>{video.description}</Typography>
                <video className={classes.video} controls>
                  <source src={video.url} type="video/mp4" />
                  <track
                    kind="captions"
                    srcLang="en"
                    label="English captions"
                  />
                  Your browser does not support the video tag.
                </video>
              </>
            )}
          </div>
        );
      }}
    />
  );
};

export { WatchVideoComponent };
